<div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center"
    *ngIf="loading && !errorMessage">
    <kui-loader>
    </kui-loader>
</div>

<kui-accordion class="flex-1">
    <div class='section-group'
        *ngFor="let group of sectionGroups"
        [class.active]="activeCard === group.name">
        <kui-card-header [active]="activeCard === group.name"
            (click)="onCardClick(group.name)">
            <kui-card-title>
                {{ group.name }}
            </kui-card-title>
            <ul class="content-card-actions">
                <!-- ACTIONS -->
                <ng-container *ngIf="activeCard === group.name">
                    <li *ngFor="let action of group.actions"
                        class="mr-1">
                        <ng-container *ngIf="action.menu || action.template; else icon;">
                            <kui-dropdown [style]="'none'"
                                [menu]="action.menu"
                                [customContent]="action.template"
                                [customContentContext]="action.templateContext">
                                <kui-icon kui-action
                                    size="sm"
                                    [name]="action.icon"
                                    [class.active]="action.active"
                                    [title]="action.name"></kui-icon>

                            </kui-dropdown>
                        </ng-container>
                        <ng-template #icon>
                            <kui-icon kui-action
                                size="sm"
                                [class.active]="action.active"
                                [name]="action.icon"
                                [title]="action.name"
                                (click)="action.click()">
                            </kui-icon>
                        </ng-template>
                    </li>
                </ng-container>
                <li>
                    <kui-icon name="chevron-up"></kui-icon>
                </li>
            </ul>
        </kui-card-header>
        <kui-card-body>
            <kui-card-text class="d-flex flex-column w-100">

                <div class='section w-100 flex-column'
                    [class.d-flex]="section.type === 'list'"
                    [class.flex-1]="section.type === 'list'"
                    *ngFor="let section of group.sections"
                    [ngSwitch]="section.type">

                    <div *ngIf="(entity || section.bulk) && !section.hidden"
                        [class.disabled]="editing && (section !== editing)"
                        class='flex-1 d-flex w-100 flex-column'>

                        <key-admin-form-editor *ngSwitchCase="'form'"
                            [editable]="!editing"
                            [entity]="entity"
                            [handler]="section"
                            (onEditing)="onEntityEditing(section, $event)"
                            (onSaving)="onEntitySaving()"
                            (onSaved)="onEntitySaved($event)"></key-admin-form-editor>

                        <key-admin-contact-editor *ngSwitchCase="'contacts'"
                            [editable]="!editing"
                            [entity]="entity"
                            [handler]="section"
                            (onEditing)="onEntityEditing(section, $event)"
                            (onSaving)="onEntitySaving()"
                            (onSaved)="onEntitySaved($event)"></key-admin-contact-editor>

                        <key-admin-list-editor *ngSwitchCase="'list'"
                            class="d-flex flex-1 flex-column w-100"
                            [editable]="!editing"
                            [entity]="entity"
                            [handler]="section"
                            (onEditing)="onEntityEditing(section, $event)"
                            (onSaving)="onEntitySaving()"
                            (onSaved)="onEntitySaved($event)"></key-admin-list-editor>

                        <key-admin-inline-list-editor *ngSwitchCase="'inline-list'"
                            [editable]="!editing"
                            [entity]="entity"
                            [handler]="section"
                            (onEditing)="onEntityEditing(section, $event)"
                            (onSaving)="onEntitySaving()"
                            (onSaved)="onEntitySaved($event)"></key-admin-inline-list-editor>

                        <key-admin-zone-editor *ngSwitchCase="'zone'"
                            class="d-flex flex-1 flex-column w-100"
                            [editable]="!editing"
                            [entity]="entity"
                            [handler]="section"
                            (onEditing)="onEntityEditing(section, $event)"
                            (onSaving)="onEntitySaving()"
                            (onSaved)="onEntitySaved($event)"></key-admin-zone-editor>

                        <key-admin-chart *ngSwitchCase="'chart'"
                            class="d-flex flex-1 flex-column w-100"
                            [entity]="entity"
                            [handler]="section"
                            [visible]="activeCard === group.name"></key-admin-chart>

                        <key-admin-media *ngSwitchCase="'media'"
                            class="d-flex flex-1 flex-column w-100"
                            [entity]="entity"
                            [handler]="section"
                            [visible]="activeCard === group.name"></key-admin-media>

                        <key-admin-custom *ngSwitchCase="'custom'"
                            class="d-flex flex-1 flex-column w-100"
                            [entity]="entity"
                            [handler]="section"
                            [visible]="activeCard === group.name"></key-admin-custom>

                        <key-admin-feed *ngSwitchCase="'feed'"
                            class="d-flex flex-1 flex-column w-100"
                            [entity]="entity"
                            [handler]="section"
                            [visible]="activeCard === group.name"></key-admin-feed>

                        <div *ngSwitchDefault>No editor found for type "{{ section.type }}"</div>
                    </div>
                </div>

                <div *ngIf="group.warnings">
                    <div *ngFor="let warning of group.warnings"
                        class="p-4 d-flex flex-stretch border-bottom">
                        <kui-icon name="exclamation-triangle"
                            color="danger"
                            class="px-2 pt-1"
                            size="lg"></kui-icon>
                        <span class='pl-3'
                            [innerHTML]="warning"></span>
                    </div>
                </div>


                <div *ngIf="group.message"
                    class="p-4 h-100 d-flex flex-stretch justify-content-center align-items-center">
                    <kui-icon name="exclamation-triangle"
                        class="px-3"
                        size="lg"></kui-icon>
                    <span>{{group.message}}</span>
                </div>
                <!-- <div style="height: 10px"></div> -->
            </kui-card-text>
        </kui-card-body>
    </div>

    <div *ngFor="let panel of customPanels"
        class='section-group'
        [class.active]="activeCard === panel.title">

        <kui-card-header [active]="activeCard === panel.title"
            (click)="onCardClick(panel.title)">
            <kui-card-title>
                {{ panel.title }}
            </kui-card-title>
            <ul class="content-card-actions">
                <li>
                    <kui-icon name="chevron-up"></kui-icon>
                </li>
            </ul>
        </kui-card-header>
        <kui-card-body>
            <kui-card-text class='section'>
                <div class='section h-100'>

                    <iframe *ngIf="panel.activated"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        [src]="panel.url">
                    </iframe>

                </div>
            </kui-card-text>
        </kui-card-body>
    </div>

    <div class='section-group'
        [class.active]="activeCard === changesTitle"
        *ngIf="changesVisible">

        <kui-card-header [active]="activeCard === changesTitle"
            (click)="onCardClick(changesTitle)">
            <kui-card-title>
                {{ changesTitle }}
            </kui-card-title>
            <ul class="content-card-actions">
                <li>
                    <kui-icon name="chevron-up"></kui-icon>
                </li>
            </ul>
        </kui-card-header>
        <kui-card-body>
            <kui-card-text class='section'>
                <div class='section h-100'>
                    <key-feed *ngIf="entity && activeCard === changesTitle"
                        type="audit"
                        originType="asset"
                        [clientId]="company"
                        [id]="auditId"
                        [showDetailsModal]="true"
                        primaryAction="detailsModal"></key-feed>
                </div>
            </kui-card-text>
        </kui-card-body>
    </div>


</kui-accordion>

<kui-alert-panel [message]="errorMessage"></kui-alert-panel>